/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumCollectionInfoModelSchema } from "../albumCollectionInfoModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAlbumCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

/**
 * @description Выпуск
 */
export const getApiAlbumCollectionsId200Schema = z.lazy(() => albumCollectionInfoModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAlbumCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAlbumCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAlbumCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Выпуск не найден
 */
export const getApiAlbumCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAlbumCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAlbumCollectionsIdQueryResponseSchema = z.lazy(() => getApiAlbumCollectionsId200Schema)